var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoModeSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9902 0C26.374 0 33.9814 7.60743 33.9814 16.9912C33.9812 26.3748 26.3739 33.9814 16.9902 33.9814C7.60667 33.9813 0.000197927 26.3748 0 16.9912C0 7.6075 7.60655 0.000115291 16.9902 0ZM16.9902 4.33203C9.99932 4.33223 4.33203 10.0003 4.33203 16.9912C4.33218 23.982 9.99942 29.6492 16.9902 29.6494C23.9812 29.6494 29.6493 23.9822 29.6494 16.9912C29.6494 10.0001 23.9813 4.33203 16.9902 4.33203Z",
    fill: "#040626"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9903,
    cy: 16.9909,
    r: 7.84894,
    fill: "#040626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoModeSymbol);
export default __webpack_public_path__ + "static/media/auto_mode_symbol.02cdee06b887cbca58d1f54e315ba54f.svg";
export { ForwardRef as ReactComponent };